import d, { css as l } from "styled-components";
import { Specs as c } from "./atoms-v2736.js";
import { breakpoints as a } from "./atoms-v2125.js";
import { CardVariant as i } from "./atoms-v2109.js";
const p = (o) => {
  switch (o) {
    case i.Horizontal:
      return 0;
    case i.Standard:
    case i.Feature:
      return "var(--border-radius)";
  }
}, u = (o) => {
  switch (o) {
    case i.Horizontal:
      return "stretch";
    case i.Standard:
      return "start";
    case i.Feature:
      return "center";
  }
}, g = (o) => {
  switch (o) {
    case i.Horizontal:
      return 0;
    case i.Standard:
      return "8px";
    case i.Feature:
      return "0 0 8px";
  }
}, s = d.div`
  --border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusSm")}px;

  align-items: ${({ $variant: o }) => o && u(o)};
  border-radius: ${({ $variant: o }) => o && [i.Horizontal, i.Standard].includes(o) ? "8px" : "var(--border-radius)"};
  color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  cursor: ${({ $isLinked: o }) => o ? "pointer" : "default"};
  display: flex;
  flex-direction: ${({ $variant: o }) => o && [i.Feature, i.Standard].includes(o) ? "column" : "row"};
  overflow: hidden;
  padding: ${({ $variant: o }) => o && g(o)};
  pointer-events: ${({ $isDisabled: o }) => o ? "none" : "auto"};
  position: relative;
  row-gap: 6px;
  text-decoration: none;
  transition: color ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.moderate.02")}
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};

  &:hover {
    color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
    outline: 1px solid
      ${({ $variant: o, theme: r }) => o && o === i.Horizontal ? r == null ? void 0 : r.get("ui.misc.light.focus.default") : "transparent"};

    ${c} {
      color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
    }
  }

  &:focus-visible {
    outline: 1px solid ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`ui.card.${o}.focus`)};
  }

  @media (width < ${({ theme: o }) => o == null ? void 0 : o.get("tokens.breakpoints.xLarge.size")}px) {
    outline: ${({ $variant: o, theme: r }) => o && o === i.Horizontal ? `1px solid ${r == null ? void 0 : r.get("tokens.border.light.disabled")}` : "none"};
  }

  @media ${a.medium} {
    --border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusMed")}px;

    row-gap: 10px;
  }
`, w = d.figure`
  align-self: stretch;
  aspect-ratio: ${({ $aspectRatio: o }) => o};
  border-radius: ${({ $isSkeleton: o, $variant: r }) => r && o ? p(r) : "none"};
  flex-shrink: 0;
  margin: 0;
  overflow: ${({ $isSkeleton: o }) => o ? "hidden" : "visible"};
  position: relative;
  width: ${({ $variant: o }) => o && o === i.Horizontal ? "116px" : "auto"};

  & picture {
    border-radius: ${({ $variant: o }) => o && p(o)};
    overflow: hidden;
  }

  @media (prefers-reduced-motion: no-preference) {
    & img {
      transition-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.moderate.01")};
      transition-property: transform;
      transition-timing-function: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};

      ${s}:hover & {
        transform: scale(1.1);
        transition-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.moderate.02")};
      }
    }
  }

  @media ${a.medium} {
    --border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusMed")}px;

    width: ${({ $variant: o }) => o && o === i.Horizontal ? "180px" : "auto"};
  }
`, H = d.figcaption`
  ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.helper.xs-productive")) == null ? void 0 : r.toJS();
}};
  --offset: 16px;

  background-color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.surface.${o}.background`)};
  border-radius: 2px;
  box-sizing: border-box;
  color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  inset: var(--offset) auto auto var(--offset);
  max-width: calc(100% - (var(--offset) * 2));
  padding: 3px 6px 4px;
  position: absolute;
  z-index: 1;

  @media ${a.medium} {
    ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : r.toJS();
}};
  }
`, z = d.div`
  align-items: ${({ $variant: o }) => o && o === i.Feature ? "center" : "start"};
  display: flex;
  flex-direction: column;
  padding: ${({ $variant: o }) => o && o === i.Horizontal ? "12px 16px 14px 20px" : 0};
  row-gap: ${({ $variant: o }) => o && o === i.Standard ? 16 : 4}px;

  @media ${a.medium} {
    padding: ${({ $variant: o }) => o && o === i.Horizontal ? "16px 20px" : 0};
  }
`, J = d.div`
  ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : r.toJS();
}};

  color: ${({ $colorTheme: o = "light", $variant: r, theme: n }) => r === i.Standard ? n == null ? void 0 : n.get(`tokens.text.${o}.tertiary`) : n == null ? void 0 : n.get(`tokens.text.${o}.primary`)};
  display: ${({ $variant: o }) => o && o === i.Horizontal ? "none" : "flex"};
  flex-direction: column;
  row-gap: 2px;

  ${s}:hover & {
    color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  }

  @media ${a.medium} {
    ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : r.toJS();
}};

    ${({ $variant: o }) => o && o === i.Horizontal && l`
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
      `}
  }
`, x = d.div`
  ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : r.toJS();
}};

  @media ${a.medium} {
    ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : r.toJS();
}};
  }
`;
x.displayName = "Card.Body";
const C = d.header`
  display: flex;
  flex-direction: column;
  flex-grow: ${({ $variant: o }) => o && o === i.Horizontal ? 1 : 0};
  row-gap: 2px;
`, $ = d.h3`
  ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : r.toJS();
}};
  margin: 0;

  @media ${a.medium} {
    ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.expressive")) == null ? void 0 : r.toJS();
}};
  }
`;
$.displayName = "Card.Header";
const f = d.h4`
  ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : r.toJS();
}};

  color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.tertiary`)};
  margin: 0;

  ${s}:hover & {
    color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  }

  @media ${a.medium} {
    ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : r.toJS();
}};
  }
`;
f.displayName = "Card.SubHeader";
const F = d.footer`
  column-gap: 8px;
  display: flex;
  justify-content: ${({ $variant: o }) => o && o === i.Feature ? "center" : "start"};
`, k = d.div`
  display: block;
`;
k.displayName = "Card.Footer";
const W = d.div`
  ${({ $variant: o, theme: r }) => {
  var n, t;
  return o && o === i.Horizontal ? (n = r == null ? void 0 : r.get("tokens.helper.productive")) == null ? void 0 : n.toJS() : (t = r == null ? void 0 : r.get("tokens.body.compact-productive")) == null ? void 0 : t.toJS();
}};

  ${s}:hover & {
    color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  }

  @media ${a.medium} {
    ${({ $variant: o, theme: r }) => {
  var n, t;
  return o && o === i.Horizontal ? (n = r == null ? void 0 : r.get("tokens.body.productive")) == null ? void 0 : n.toJS() : (t = r == null ? void 0 : r.get("tokens.body.compact-expressive")) == null ? void 0 : t.toJS();
}};
  }
`, e = d.div`
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
`;
e.displayName = "Card.CallToAction";
const M = d.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${({ $isHeader: o }) => o ? 28 : 20}px;
`;
export {
  x as Body,
  J as BodyWrapper,
  e as CallToAction,
  W as CallToActionWrapper,
  z as ContentWrapper,
  k as Footer,
  F as FooterWrapper,
  $ as Header,
  C as HeaderWrapper,
  H as MediaLabel,
  w as MediaWrapper,
  M as SkeletonRow,
  f as Subheader,
  s as Wrapper
};
